const comments = [
  {
    name: '影迷小张',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20user%20avatar%20with%20warm%20beige%20background%2C%20abstract%20geometric%20design%2C%20soft%20round%20shape%2C%20clean%20modern%20aesthetic&width=100&height=100&seq=mahua-avatar-01&orientation=squarish',
    text: '麻花影院真的太良心了！不用注册不用付费，最新的大片全都有。画质也很清晰，推荐给了好多朋友，大家都说好用。',
    date: '2天前',
    stars: 5,
  },
  {
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20user%20avatar%20with%20warm%20terracotta%20background%2C%20simple%20abstract%20pattern%2C%20clean%20circular%20design%2C%20modern%20flat%20style&width=100&height=100&seq=mahua-avatar-02&orientation=squarish',
    text: '更新速度真的快，迷雾追踪刚播完就全集上线了，一口气看完的感觉太爽了。网站也不卡，体验一级棒！',
    date: '3天前',
    stars: 5,
  },
  {
    name: '电影爱好者老王',
    avatar: 'https://readdy.ai/api/search-image?query=Clean%20minimal%20user%20avatar%20with%20warm%20golden%20background%2C%20simple%20geometric%20shape%2C%20soft%20modern%20design%2C%20circular%20format&width=100&height=100&seq=mahua-avatar-03&orientation=squarish',
    text: '找了好几个免费网站，就麻花影院最稳定。片源多，分类清楚，还有榜单和话题可以参考。希望一直保持下去！',
    date: '5天前',
    stars: 4,
  },
  {
    name: '周末影院',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20user%20avatar%20with%20warm%20coral%20background%2C%20simple%20abstract%20art%2C%20clean%20modern%20circle%20design%2C%20flat%20style&width=100&height=100&seq=mahua-avatar-04&orientation=squarish',
    text: '周末在家用电视投屏看了一整天，太舒服了。纪录片板块也很棒，动物星球那个特辑拍得太美了。强烈推荐！',
    date: '6天前',
    stars: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            用户热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            听听麻花影院免费观看用户们的真实感受
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="rounded-xl p-5 md:p-6 bg-background-100 border border-background-200/70"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900">
                      {comment.name}
                    </h3>
                    <span className="text-[11px] text-foreground-400">{comment.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {Array.from({ length: comment.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-primary-500"></i>
                    ))}
                    {Array.from({ length: 5 - comment.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-background-300"></i>
                    ))}
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {comment.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}